web = {
	storage_name: "metco",
	labels: {},
	reload_time: 800,
};

web.initialize_app = function () {
	moment.locale(web.current_language_code);
	web.get("/functions/_lib/labels.php", function (result, labels) {
		web.labels = JSON.parse(labels);
		web.labels = web.labels[web.current_language_code];
	});

	$(".sign-in-button").off("click").on("click", function () {
		web.display_sign_in(function () {
			console.log("signed in")
		});
	});
	$(".sign-up-button").off("click").on("click", function () {
		web.display_sign_up(function () {
			console.log("signed up")
		});
	});
	$(".sign-out-button").on("click", function () {
		web.sign_out(function () {
			console.log("signed out")
		});
	});

	$(window).on("user.signed_in", function () {
		location.reload();
	});
	$(window).on("user.signed_out", function () {
		location.reload();
	});

	web.is_visible = (entries, observer) => {
		entries.forEach(entry => {
			entry.target.classList.toggle("visible", entry.isIntersecting);
		});
	};

	web.obs = new IntersectionObserver(web.is_visible);
	options = {};

	$("[data-is-visible]").each(function () {
		web.obs.observe(this, options);
	});
};

//toast
web.display_message = function (type, message) {
	if (type == "error") {
		node = $("#toast-container .toast.error");
	}
	if (type == "normal") {
		node = $("#toast-container .toast.normal");
	}
	if (type == "info") {
		node = $("#toast-container .toast.info");
	}
	if (type == "success") {
		node = $("#toast-container .toast.success");
	}
	if (type == "warning") {
		node = $("#toast-container .toast.warning");
	}
	node.find(".toast-message").text(message);
	web.toast = new bootstrap.Toast(node.get(0));
	web.toast.show();
};

web.normal_message = function (message) {
	if (message) {
		web.display_message("normal", message);
	}
	else {
		web.display_message("normal");
	}
};

web.info_message = function (message) {
	if (message) {
		web.display_message("info", message);
	}
	else {
		web.display_message("info");
	}
};

web.success_message = function (message) {
	if (message) {
		web.display_message("success", message);
	}
	else {
		web.display_message("success", web.labels.operation_completed);
	}
};

web.error_message = function (message) {
	if (message) {
		web.display_message("error", message);
	}
	else {
		web.display_message("error", web.labels.operation_not_completed);
	}
};

web.warning_message = function (message) {
	web.display_message("warning", message);
};

web.reload_page = function (reload_time) {
	if (reload_time == undefined) {
		reload_time = web.reload_time;
	}
	setTimeout(function () {
		location.reload();
	}, reload_time)
};

//modals
web.display_kvkk_modal = function (options, call_back) {
	$("#kvkk-modal").remove();
	web.get("/modals/kvkk.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			setTimeout(function () {
				initialize_kvkk_modal(options, call_back);
			}, 1000);


			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#kvkk-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: false,
				backdrop: "static"
			});

			web.modal.show();
		}
	});
};

web.display_member_verification_modal = function (options, call_back) {
	$("#member-verification-modal").remove();
	web.get("/modals/member_verification.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");
			setTimeout(function () {
				initialize_verification_modal(options, call_back);
			}, 1000);


			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#member-verification-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: false,
				backdrop: "static"
			});

			web.modal.show();
		}
	});
};

web.display_password_change = async function () {
	if (web.modal) {
		await web.modal.hide();
	}
	$("#password-chamge-modal").remove();
	web.get("/modals/password_change.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			if ($html) {
				web.modal = new bootstrap.Modal($html.get(0), {
					keyboard: true,
					focus: true,
					backdrop: "static",
				});

				$html.on("hidden.bs.modal", function () {
					if (web.modal) {
						web.modal.dispose();
					}
					$("#password-change-modal").remove();
				});

				web.modal.show();
			}
		}
	});
};

web.display_password_reset = async function () {
	if (web.modal) {
		await web.modal.hide();
	}
	$("#password-reset-modal").remove();
	web.get("/modals/password_reset.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			if ($html) {
				web.modal = new bootstrap.Modal($html.get(0), {
					keyboard: true,
					focus: true,
					backdrop: "static",
				});

				$html.on("hidden.bs.modal", function () {
					if (web.modal) {
						web.modal.dispose();
					}
					$("#password-reset-modal").remove();
				});

				web.modal.show();
			}
		}
	});
};

web.display_policies_modal = function (options) {
	web.get("/modals/policies_modal.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.on("hidden.bs.modal", function () {
				if (policies_modal) {
					policies_modal.dispose();
				}
				$("#policies-modal").remove();
			});
			policies_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			policies_modal.show();
		}
	});
};

web.display_sign_in = async function () {
	if (web.modal) {
		await web.modal.hide();
	}
	web.get("/modals/sign_in.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			if ($html) {
				web.modal = new bootstrap.Modal($html.get(0), {
					keyboard: true,
					focus: true,
					backdrop: "static",
				});

				$html.on("hidden.bs.modal", function () {
					if (web.modal) {
						web.modal.dispose();
					}
					$("#sign-in-modal").remove();
				});

				web.modal.show();
			}
		}
	});
};

web.display_sign_up = async function () {
	if (web.modal) {
		await web.modal.hide();
	}
	$("#sign-up-modal").remove();
	web.get("/modals/sign_up.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			if ($html) {
				web.modal = new bootstrap.Modal($html.get(0), {
					keyboard: true,
					focus: true,
					backdrop: "static",
				});

				$html.on("hidden.bs.modal", function () {
					if (web.modal) {
						web.modal.dispose();
					}
					$("#sign-up-modal").remove();
				});

				web.modal.show();
			}
		}
	});
};

web.display_support_modal = function (options, call_back) {
	web.get("/modals/support.php", function (result, html) {
		if (result == 1) {
			$html = $(html).appendTo("#modal-container");

			$html.on("hidden.bs.modal", function () {
				if (web.modal) {
					web.modal.dispose();
				}
				$("#support-modal").remove();
			});

			web.modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});
			web.modal.show();
		}
	});
};

web.display_thanks_modal = function (options) {
	web.get("/modals/thanks.php", function (result, html) {
		if (result == 1) {
			$("#thanks-modal").remove();
			$html = $(html).appendTo("#modal-container");

			$html.find("#ok").on("click", function () {
				if (web.thanks_modal) {
					web.thanks_modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (web.thanks_modal) {
					web.thanks_modal.dispose();
				}
				$("#thanks-modal").remove();
			});

			web.thanks_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			web.thanks_modal.show();
		}
	});
};
//auth
web.sign_in = function (data, call_back) {
	try {
		web.post("auth", {
			action: "sign_in",
			data: data
		}, function (result, data) {
			if (result == 1) {
				if (data.success == 1) {
					web.success_message();
					if (call_back) {
						call_back(data);
					}
					$(window).trigger("user.signed_in");
				}
				else {
					web.display_message("error", web.labels.email_or_password_not_correct);
				}
			} else {
				web.display_message("error", web.labels.email_or_password_not_correct);
			}
		});
	} catch (err) {
		console.log(err);
	}
}

web.sign_out = function () {
	web.post(
		"auth",
		{
			action: "sign_out",
		},
		function (result, data) {
			if (data && data.success == 1) {
				location.href = "/";
			}
		}
	);
};

//utils
web.is_email = function (email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
};

//ajax
web.get = function (target, call_back) {
	$.get(target, function (html) {
		call_back(1, html);
	}).fail(function (jqXHR, textStatus) {
		console.log("Request failed:" + textStatus);
		call_back(0);
	});
};

//auth
web.sign_out = function () {
	web.post(
		"auth",
		{
			action: "sign_out",
		},
		function (result, data) {
			if (data && data.success == 1) {
				location.href = "/";
			}
		}
	);
};

//arrays

web.get_array_item = function (arr, fld, val) {
	target = null;
	arr.forEach((item) => {
		if (item[fld] == val) {
			target = item;
		}
	});
	return target;
}

web.get_array_items = function (arr, fld, val) {
	items = [];
	arr.forEach((item) => {
		if (item[fld] == val) {
			items.push(item);
		}
	});
	return items;
}

//favorites
web.get_favorites = function () {
	const storage_key = web.storage_name + "_favorites";
	const favorites_json = localStorage.getItem(storage_key);

	if (favorites_json) {
		try {
			return JSON.parse(favorites_json);
		} catch (e) {
			console.error("Error parsing favorites:", e);
			return [];
		}
	}
	return [];
}

web.is_favorite = function (product_id) {
	const favorites = web.get_favorites();
	return favorites.includes(parseInt(product_id));
}

web.add_to_favorites = function (product_id) {
	const storage_key = web.storage_name + "_favorites";
	let favorites = web.get_favorites();

	product_id = parseInt(product_id);

	if (!favorites.includes(product_id)) {
		favorites.push(product_id);
		localStorage.setItem(storage_key, JSON.stringify(favorites));
		$(window).trigger("favorites.updated", [favorites]);
		return true;
	}
	return false;
}

web.remove_from_favorites = function (product_id) {
	const storage_key = web.storage_name + "_favorites";
	let favorites = web.get_favorites();

	product_id = parseInt(product_id);

	const index = favorites.indexOf(product_id);
	if (index > -1) {
		favorites.splice(index, 1);
		localStorage.setItem(storage_key, JSON.stringify(favorites));
		$(window).trigger("favorites.updated", [favorites]);
		return true;
	}
	return false;
}

web.toggle_favorite = function (product_id) {
	if (web.is_favorite(product_id)) {
		return web.remove_from_favorites(product_id);
	} else {
		return web.add_to_favorites(product_id);
	}
}

web.clear_favorites = function () {
	const storage_key = web.storage_name + "_favorites";
	localStorage.removeItem(storage_key);
	$(window).trigger("favorites.updated", [[]]);
}

web.initialize_favorites = function (options) {
	options = options || {};
	const onRemove = options.onRemove || null;
	const addedMessage = options.addedMessage || null;
	const removedMessage = options.removedMessage || null;

	// Update all favorite button states
	function updateFavoriteButtons() {
		$('.product-card, .favorite-bar').each(function () {
			const $card = $(this);
			const productId = $card.data('product-id');
			const $btn = $card.find('.favorite-button');
			const $addIcon = $btn.find('.add');
			const $removeIcon = $btn.find('.remove');

			if (web.is_favorite(productId)) {
				$addIcon.addClass('d-none');
				$removeIcon.removeClass('d-none');
			} else {
				$addIcon.removeClass('d-none');
				$removeIcon.addClass('d-none');
			}
		});
	}

	// Initialize on page load
	updateFavoriteButtons();

	// Handle favorite button clicks
	$(document).on('click', '.favorite-button', function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $btn = $(this);
		const $card = $btn.closest('.product-card, .favorite-bar');
		const productId = $card.data('product-id');
		const $addIcon = $btn.find('.add');
		const $removeIcon = $btn.find('.remove');

		if (web.is_favorite(productId)) {
			web.remove_from_favorites(productId);
			$addIcon.removeClass('d-none');
			$removeIcon.addClass('d-none');

			// Call custom onRemove callback if provided
			if (onRemove && typeof onRemove === 'function') {
				onRemove($card, productId);
			}

			// Show message
			if (removedMessage) {
				web.normal_message(removedMessage);
			} else if (web.labels.removed_from_favorites) {
				web.normal_message(web.labels.removed_from_favorites);
			}
		} else {
			web.add_to_favorites(productId);
			$addIcon.addClass('d-none');
			$removeIcon.removeClass('d-none');

			// Show message
			if (addedMessage) {
				web.success_message(addedMessage);
			} else if (web.labels.added_to_favorites) {
				web.success_message(web.labels.added_to_favorites);
			}
		}
	});

	// Listen for favorites updates from other tabs/windows
	$(window).on('favorites.updated', function () {
		updateFavoriteButtons();
	});
}

//policies
web.display_kvkk_clarification_text_modal = function (options) {
	web.get("/modals/kvkk_clarification_text.php", function (result, html) {
		if (result == 1) {
			$("#kvkk-clarification-text-modal").remove();
			$html = $(html).appendTo("#modal-container");

			$html.find(".close-button").on("click", function () {
				if (kvkk_clarification_text_modal) {
					kvkk_clarification_text_modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (kvkk_clarification_text_modal) {
					kvkk_clarification_text_modal.dispose();
				}
				$("#kvkk-clarification-text-modal").remove();
			});

			kvkk_clarification_text_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			kvkk_clarification_text_modal.show();
		}
	});
};

web.display_kvkk_policy_modal = function (options) {
	web.get("/modals/kvkk_policy.php", function (result, html) {
		if (result == 1) {
			$("#kvkk-policy-modal").remove();
			$html = $(html).appendTo("#modal-container");

			$html.find(".close-button").on("click", function () {
				if (kvkk_policy_modal) {
					kvkk_policy_modal.hide();
				}
			});

			$html.on("hidden.bs.modal", function () {
				if (kvkk_policy_modal) {
					kvkk_policy_modal.dispose();
				}
				$("#kvkk-policy-modal").remove();
			});

			kvkk_policy_modal = new bootstrap.Modal($html.get(0), {
				keyboard: true,
			});

			kvkk_policy_modal.show();
		}
	});
};

//objects
web.copy_object = function (obj) {
	return JSON.parse(JSON.stringify(obj));
}

//xhr
web.post = function (target, p, call_back) {
	$.post("/functions/" + target + ".php", JSON.stringify(p), function (data) {
		if (call_back) {
			call_back(1, data);
		}
	}).fail(function (jqXHR, textStatus) {
		console.log("Request failed:" + textStatus);
		if (call_back) {
			call_back(0);
		}
	});
};

web.post_form = function (target, data, call_back) {
	$.ajax({
		url: "/functions/" + target + ".php",
		dataType: "text",
		cache: false,
		contentType: false,
		processData: false,
		data: data,
		type: "post",
		success: function (data) {
			if (call_back) {
				call_back(1, data);
			}
		},
		error: function (jqXHR, textStatus) {
			console.log("Request failed:" + textStatus);
			if (call_back) {
				call_back(0);
			}
		},
	});
};

// Info box chevron rotation
web.initialize_info_box_chevrons = function () {
	const infoBoxToggles = document.querySelectorAll('.info-box [data-bs-toggle="collapse"]');

	infoBoxToggles.forEach(toggle => {
		const chevronIcon = toggle.querySelector('.chevron-icon svg');
		const collapseTarget = document.querySelector(toggle.getAttribute('href'));

		if (chevronIcon && collapseTarget) {
			// Add transition class to chevron
			chevronIcon.style.transition = 'transform 0.3s ease';

			// Listen for collapse events
			collapseTarget.addEventListener('show.bs.collapse', function () {
				chevronIcon.style.transform = 'rotate(180deg)';
				toggle.setAttribute('aria-expanded', 'true');
			});

			collapseTarget.addEventListener('hide.bs.collapse', function () {
				chevronIcon.style.transform = 'rotate(0deg)';
				toggle.setAttribute('aria-expanded', 'false');
			});
		}
	});
};

// Image zoom functionality for carousels
web.initialize_carousel_zoom = function (carouselId) {
	const carousel = document.getElementById(carouselId);
	if (!carousel) return;

	const zoomableImages = carousel.querySelectorAll('.zoomable-image');

	zoomableImages.forEach(image => {
		const container = image.closest('.image-zoom-container');

		if (container) {
			// Handle mouse move for zoom positioning
			container.addEventListener('mousemove', function (e) {
				if (image.matches(':hover')) {
					const rect = container.getBoundingClientRect();
					const x = ((e.clientX - rect.left) / rect.width) * 100;
					const y = ((e.clientY - rect.top) / rect.height) * 100;

					image.style.transformOrigin = `${x}% ${y}%`;
				}
			});

			// Reset transform origin when mouse leaves
			container.addEventListener('mouseleave', function () {
				image.style.transformOrigin = 'center center';
			});
		}
	});
};

// Carousel thumbnail functionality
web.initialize_carousel_thumbnails = function (carouselId) {
	const carousel = document.getElementById(carouselId);
	if (!carousel) return;

	const carouselInstance = bootstrap.Carousel.getOrCreateInstance(carousel);
	const thumbnailsContainer = carousel.querySelector('.carousel-thumbnails');
	const thumbnails = carousel.querySelectorAll('.thumbnail-item');
	const prevBtn = carousel.querySelector('.thumbnail-nav.prev');
	const nextBtn = carousel.querySelector('.thumbnail-nav.next');

	if (!thumbnailsContainer || thumbnails.length === 0) return;

	// Calculate scroll amount (width of one thumbnail + gap)
	const scrollAmount = 118; // 110px width + 8px gap

	// Check if navigation buttons are needed
	function updateNavButtons() {
		// Wait for elements to be rendered
		setTimeout(() => {
			const containerWidth = thumbnailsContainer.offsetWidth;
			const scrollWidth = thumbnailsContainer.scrollWidth;
			const needsNavigation = scrollWidth > containerWidth;

			if (needsNavigation) {
				prevBtn.classList.add('show');
				nextBtn.classList.add('show');
			} else {
				prevBtn.classList.remove('show');
				nextBtn.classList.remove('show');
			}

			// Update button states based on scroll position
			updateScrollButtons();
		}, 100);
	}

	// Update scroll button states
	function updateScrollButtons() {
		const scrollLeft = thumbnailsContainer.scrollLeft;
		const maxScroll = thumbnailsContainer.scrollWidth - thumbnailsContainer.offsetWidth;

		prevBtn.style.opacity = scrollLeft > 0 ? '1' : '0.5';
		nextBtn.style.opacity = scrollLeft < maxScroll ? '1' : '0.5';
	}

	// Scroll thumbnails
	function scrollThumbnails(direction) {
		const scrollLeft = thumbnailsContainer.scrollLeft;
		const newScrollLeft = direction === 'next' ?
			scrollLeft + scrollAmount * 3 :
			scrollLeft - scrollAmount * 3;

		thumbnailsContainer.scrollTo({
			left: newScrollLeft,
			behavior: 'smooth'
		});
	}

	// Center active thumbnail in view
	function centerActiveThumbnail(activeIndex) {
		const thumbnail = thumbnails[activeIndex];
		if (thumbnail) {
			const thumbnailRect = thumbnail.getBoundingClientRect();
			const containerRect = thumbnailsContainer.getBoundingClientRect();
			const scrollLeft = thumbnailsContainer.scrollLeft;
			const targetScroll = scrollLeft + thumbnailRect.left - containerRect.left -
				(containerRect.width / 2) + (thumbnailRect.width / 2);

			thumbnailsContainer.scrollTo({
				left: targetScroll,
				behavior: 'smooth'
			});
		}
	}

	// Handle thumbnail clicks
	thumbnails.forEach((thumbnail, index) => {
		thumbnail.addEventListener('click', function () {
			// Remove active class from all thumbnails
			thumbnails.forEach(thumb => thumb.classList.remove('active'));

			// Add active class to clicked thumbnail
			this.classList.add('active');

			// Slide to the corresponding carousel item
			carouselInstance.to(index);

			// Center the active thumbnail
			centerActiveThumbnail(index);
		});
	});

	// Handle navigation button clicks
	if (prevBtn && nextBtn) {
		prevBtn.addEventListener('click', () => scrollThumbnails('prev'));
		nextBtn.addEventListener('click', () => scrollThumbnails('next'));
	}

	// Update thumbnail active state when carousel slides
	carousel.addEventListener('slide.bs.carousel', function (e) {
		const activeIndex = e.to;

		thumbnails.forEach((thumb, index) => {
			if (index === activeIndex) {
				thumb.classList.add('active');
			} else {
				thumb.classList.remove('active');
			}
		});

		// Center the active thumbnail
		centerActiveThumbnail(activeIndex);
	});

	// Listen for scroll events to update button states
	thumbnailsContainer.addEventListener('scroll', updateScrollButtons);

	// Initialize navigation on load and resize
	updateNavButtons();
	window.addEventListener('resize', updateNavButtons);

	// Force initial check after images load
	thumbnails.forEach(thumbnail => {
		const img = thumbnail.querySelector('img');
		if (img) {
			img.addEventListener('load', updateNavButtons);
		}
	});
};

// Water Ripple Effect Functions
web.initialize_ripple_effects = function () {
	// Initialize interactive ripple effects
	$('.rt-water-ripple-interactive').on('click', function (e) {
		const $this = $(this);
		const rect = this.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;

		// Create ripple element
		const $ripple = $('<span class="click-ripple"></span>');
		$ripple.css({
			position: 'absolute',
			left: x - 25 + 'px',
			top: y - 25 + 'px',
			width: '50px',
			height: '50px',
			borderRadius: '50%',
			background: 'radial-gradient(circle, rgba(74, 144, 226, 0.6) 0%, rgba(80, 170, 250, 0.4) 50%, transparent 70%)',
			transform: 'scale(0)',
			animation: 'ripple 0.6s ease-out forwards',
			zIndex: 10,
			pointerEvents: 'none'
		});

		$this.append($ripple);

		// Remove ripple after animation
		setTimeout(() => {
			$ripple.remove();
		}, 600);
	});

	// Auto-generate bubbles for animated ripple sections
	$('.animated.rt-ripple').each(function () {
		const $section = $(this);

		// Add bubbles if they don't exist
		if ($section.find('.ripple-bubble').length === 0) {
			for (let i = 0; i < 8; i++) {
				$section.append('<div class="ripple-bubble"></div>');
			}
		}
	});

	// Enhanced water flow effect
	$('.rt-water-ripple').hover(
		function () {
			$(this).addClass('water-active');
		},
		function () {
			$(this).removeClass('water-active');
		}
	);
};

// Lightbox Gallery
web.lightbox = {
	currentIndex: 0,
	images: [],
	isOpen: false,

	open: function (images, startIndex) {
		// Validation
		if (!images || !Array.isArray(images) || images.length === 0) {
			console.error('Lightbox: No valid images provided', images);
			return;
		}

		this.images = images;
		this.currentIndex = startIndex || 0;

		// Ensure currentIndex is within bounds
		if (this.currentIndex < 0 || this.currentIndex >= this.images.length) {
			console.warn('Lightbox: Invalid start index', startIndex, 'defaulting to 0');
			this.currentIndex = 0;
		}

		this.isOpen = true;

		// Create lightbox HTML if it doesn't exist
		if ($('#lightbox-modal').length === 0) {
			const html = `
				<div id="lightbox-modal" class="lightbox-overlay">
					<div class="lightbox-container">
						<button class="lightbox-close" aria-label="Close">
							<i class="icon close red"></i>
						</button>
						<button class="lightbox-prev" aria-label="Previous">
							<i class="icon chevron-left lg white"></i>
						</button>
						<button class="lightbox-next" aria-label="Next">
							<i class="icon chevron-right lg white"></i>
						</button>
						<div class="lightbox-content">
							<img class="lightbox-image" src="" alt="">
							<div class="lightbox-caption"></div>
						</div>
						<div class="lightbox-counter"></div>
					</div>
				</div>
			`;
			$('body').append(html);

			// Bind events
			$('#lightbox-modal .lightbox-close').on('click', () => this.close());
			$('#lightbox-modal .lightbox-prev').on('click', () => this.prev());
			$('#lightbox-modal .lightbox-next').on('click', () => this.next());
			$('#lightbox-modal .lightbox-overlay').on('click', (e) => {
				if ($(e.target).hasClass('lightbox-overlay')) {
					this.close();
				}
			});

			// Keyboard navigation
			$(document).on('keydown.lightbox', (e) => {
				if (!this.isOpen) return;

				if (e.key === 'Escape') this.close();
				if (e.key === 'ArrowLeft') this.prev();
				if (e.key === 'ArrowRight') this.next();
			});
		}

		this.show();
		$('#lightbox-modal').addClass('active');
		$('body').addClass('lightbox-open');
	},

	show: function () {
		// Safety check
		if (!this.images || this.images.length === 0) {
			console.error('Lightbox: No images available');
			this.close();
			return;
		}

		if (this.currentIndex < 0 || this.currentIndex >= this.images.length) {
			console.error('Lightbox: Invalid image index', this.currentIndex);
			this.currentIndex = 0;
		}

		const image = this.images[this.currentIndex];

		// Additional safety check
		if (!image || !image.src) {
			console.error('Lightbox: Invalid image object', image);
			this.close();
			return;
		}

		const $modal = $('#lightbox-modal');
		const $img = $modal.find('.lightbox-image');
		const $caption = $modal.find('.lightbox-caption');
		const $counter = $modal.find('.lightbox-counter');

		// Update image
		$img.attr('src', image.src);
		$img.attr('alt', image.alt || '');

		// Update caption
		if (image.caption) {
			$caption.text(image.caption).show();
		} else {
			$caption.hide();
		}

		// Update counter
		$counter.text(`${this.currentIndex + 1} / ${this.images.length}`);

		// Show/hide navigation buttons
		if (this.images.length <= 1) {
			$modal.find('.lightbox-prev, .lightbox-next').hide();
		} else {
			$modal.find('.lightbox-prev, .lightbox-next').show();
		}
	},

	close: function () {
		this.isOpen = false;
		$('#lightbox-modal').removeClass('active');
		$('body').removeClass('lightbox-open');
	},

	next: function () {
		this.currentIndex = (this.currentIndex + 1) % this.images.length;
		this.show();
	},

	prev: function () {
		this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
		this.show();
	}
};

// Initialize lightbox from container
web.initialize_lightbox_gallery = function (containerSelector, imageSelector, options) {
	// Default selectors
	containerSelector = containerSelector || '.lightbox-gallery';
	imageSelector = imageSelector || 'img';
	options = options || {};

	// Extract options
	const hideCaption = options.hideCaption || false;

	$(containerSelector).each(function () {
		const $container = $(this);

		// Skip if already initialized
		if ($container.data('lightbox-initialized')) {
			return;
		}
		$container.data('lightbox-initialized', true);

		// Collect all images in this container
		const images = [];
		const $images = $container.find(imageSelector);

		$images.each(function () {
			const src = $(this).attr('src');
			if (src) {
				images.push({
					src: src,
					alt: $(this).attr('alt') || '',
					caption: hideCaption ? '' : ($(this).attr('title') || $(this).attr('alt') || '')
				});
			}
		});

		// Validate we have images
		if (images.length === 0) {
			console.warn('Lightbox: No valid images found in container', containerSelector);
			return;
		}

		// Make images clickable and bind events
		$images.css('cursor', 'pointer');

		$images.on('click.lightbox', function (e) {
			e.preventDefault();

			// Find the index of clicked image
			const clickedIndex = $images.index(this);

			// Validate index
			if (clickedIndex >= 0 && clickedIndex < images.length) {
				web.lightbox.open(images, clickedIndex);
			} else {
				console.error('Lightbox: Invalid click index', clickedIndex, 'of', images.length);
			}
		});

		console.log('Lightbox: Initialized', images.length, 'images in', containerSelector);
	});
};

// Cart
// Add
web.add_to_cart = function (product_id, quantity, added_message, call_back) {
	web.post("cart", { action: "add_to_cart", product_id: product_id, quantity: quantity }, function (result, data) {
		if (result == 1) {
			if (data.success == 1) {
				$(window).trigger("cart.item_added", [product_id]);
				web.load_cart_items();
				web.success_message(added_message);
			}
			else {
				web.error_message();
			}
		}
		else {
			web.error_message();
		}
		if (call_back) {
			call_back();
		}
	});
};

// Remove
web.remove_from_cart = function (product_id, removed_message, call_back) {
	web.post("cart", { action: "remove_from_cart", product_id: product_id }, function (result, data) {
		if (result) {
			if (data.success == 1) {
				$(window).trigger("cart.item_removed", [product_id]);
				web.load_cart_items();
				web.info_message(removed_message);
			}
			if (call_back) {
				call_back();
			}
		}
	});
};

// Request
web.request_proposal = function (call_back) {
	web.post("cart", { action: "request_proposal" }, function (result, data) {
		if (result) {
			if (data.success == 1) {
				web.success_message();
			}
			if (call_back) {
				call_back(data.success);
			}
		}
	});
};

// Count
web.update_cart_badge = function (count) {
	const $badge = $('#cart-count-badge');

	if (count > 0) {
		$badge.text(count).show();
	} else {
		$badge.hide();
	}
};

//Canvas
web.show_cart_offcanvas = function () {
	const offcanvas = new bootstrap.Offcanvas(document.getElementById('cart-offcanvas'));
	offcanvas.show();
};

//Load
web.load_cart_items = function () {
	const $container = $('#cart-items-container');
	const $total = $('#cart-total');

	web.post('cart', { action: 'get_cart_items' }, function (result, data) {
		if (result == 1) {
			$container.html(data.html);
			$total.html(data.total_formatted);
			web.update_cart_badge(data.count);
		}
	});
};

// Initialize cart functionality
web.initialize_cart = function (options) {
	options = options || {};
	const selector = options.selector || null;
	const added_message = options.added_message || null;
	const removed_message = options.removed_message || null;

	$(selector).on("click", ".add-to-cart-button", function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $btn = $(this);
		const product_id = $btn.data("product-id");
		$btn.prop("disabled", true);
		web.add_to_cart(product_id, 1, added_message, function () {
			$btn.prop("disabled", false);
		});
	});

	$(selector).on("click", ".remove-from-cart-button", function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $btn = $(this);
		const product_id = $btn.data("product-id");
		$btn.prop("disabled", true);
		web.remove_from_cart(product_id, removed_message, function () {
		});
	});

	$(selector).on("click", "#get-proposal-button", function (e) {
		e.preventDefault();
		e.stopPropagation();

		const $btn = $(this);
		$btn.prop("disabled", true);
		web.request_proposal(function (success) {
			console.log("proposal requested", success);
			$btn.prop("disabled", false);
		});
	});

	web.load_cart_items();
};
